import Vue from 'vue'
import Router from 'vue-router'
import Admin from './views/Admin.vue'
import AdminVip from './views/AdminVip.vue'
import AdminPages from './views/AdminPages.vue'
import AdminOrders from './views/AdminOrders.vue'
import CreatorPage from './views/CreatorPage.vue'
import YourText from './views/YourText.vue'
import Settings from './views/Settings.vue'
import Style from './views/Style.vue'
import Login from './views/Login.vue'
import ForgotPassword from './views/ForgotPassword.vue'
import SetPassword from './views/SetPassword.vue'

import VueHead from 'vue-head'
import VueScrollTo from 'vue-scrollto'
 
// You can also pass in the default options
Vue.use(VueScrollTo, {
     container: "body",
     duration: 500,
     easing: "ease",
     offset: -60,
     force: true,
     cancelable: true,
     onStart: false,
     onDone: false,
     onCancel: false,
     x: false,
     y: true
 })

Vue.use(VueHead)
Vue.use(Router)

var userRoutes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    props: {loginwebsiteid: window.myAppConfig.websiteid, creatoreditor: false}
  },
  {
    path: '/login/:websiteid',
    name: 'creatorlogin',
    component: Login
  },
  {
    path: '/',
    name: 'home',
    component: CreatorPage,
    props: {websiteid: window.myAppConfig.websiteid, creatoreditor: false}
  },
  {
    path: '/:pageslug',
    name: 'homeSubPage',
    component: CreatorPage,
    props: {websiteid: window.myAppConfig.websiteid, creatoreditor: false}
  },
  {
    path: '/detail/:pageslug',
    name: 'featureDetailLive',
    component: CreatorPage,
    props: {isfeaturedetail: true, creatoreditor: false}
  }
]

var creatorRoutes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    props: {loginwebsiteid: window.myAppConfig.websiteid, creatoreditor: false}
  },
  {
    path: '/login/:websiteid',
    name: 'creatorlogin',
    component: Login
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: ForgotPassword
  },
  {
    path: '/set-password/:id',
    name: 'setPassword',
    component: SetPassword
  },
  {
    path: '/',
    name: 'home',
    component: CreatorPage,
    props: {websiteid: window.myAppConfig.websiteid, creatorhome: true, creatoreditor: false}
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin
  },
  {
    path: '/adminpages',
    name: 'adminPages',
    component: AdminPages
  },
  {
    path: '/adminorders',
    name: 'adminOrders',
    component: AdminOrders
  },
  {
    path: '/adminvip',
    name: 'adminVip',
    component: AdminVip
  },
  {
    path: '/adminpages/:websiteid',
    name: 'adminPagesPerSite',
    component: AdminPages
  },
  {
    path: '/creator/:websiteid',
    name: 'creatorHome',
    component: CreatorPage,
    props: {creatoreditor: true, creatorhome: false}
  },
  {
    path: '/viewer/:websiteid',
    name: 'viewerHome',
    component: CreatorPage,
    props: {creatoreditor: true, creatorhome: false, readonly: true, sitecontainer: ''}
  },
  {
    path: '/creator/:websiteid/settingspage',
    name: 'settings',
    component: Settings
  },
  {
    path: '/creator/:websiteid/customstylepage',
    name: 'style',
    component: Style
  },
  {
    path: '/creator/:websiteid/:pageslug',
    name: 'creatorPage',
    component: CreatorPage,
    props: {creatoreditor: true}
  },
  {
    path: '/creator/:websiteid/detail/:pageslug',
    name: 'featureDetail',
    component: CreatorPage,
    props: {creatoreditor: true, isfeaturedetail: true}
  },
  {
    path: '/vip',
    name: 'yourText',
    component: YourText
  },
  {
    path: '/vip/:vipcode',
    component: YourText
  },
  {
    path: '/:pageslug',
    name: 'homeSubPage',
    component: CreatorPage,
    props: {websiteid: window.myAppConfig.websiteid, creatoreditor: false}
  },
  { 
    path: '/*',
    redirect: '/'
  }
]

var routes = creatorRoutes //for standalone: userRoutes

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes
})
